// ReactJS:
import todo_website from "../img/todo_website.png";
import sneakers_ecommerce from "../img/Ecommerce_website.jpeg";
import instagram_clone from "../img/instagram_clone.png";
import react_recipe_search from "../img/react_recipe_search.png";
import react_weather_app from "../img/react_weather_app.png";
import messager_clone from "../img/Messenger_website.png";
import redux_todo from "../img/redux-todo-app.png";

// Html + CSS:
import sunnyside_landing_page from "../img/sunnyside_landing_page.png";

// Web Design:
import blogPage1 from "../img/Blogs Page.jpg";
import blogPage2 from "../img/Single Blog Page.jpg";
import pricing from "../img/Pricing page.jpg";
import greencube_landing_page from "../img/Home Page Redesign.jpg";

export const reactJSProjects = [
  {
    title: "Todo App",
    img: todo_website,
    websiteUrl: "https://react-todo-app-35d00.web.app/",
    githubUrl: "https://github.com/YourNeptune/react-todo-app",
  },
  {
    title: "Sneakers Ecommerce",
    img: sneakers_ecommerce,
    websiteUrl: "https://ecommerce-site-941685.netlify.app/",
    githubUrl: "https://github.com/YourNeptune/E-commerce-product-page",
  },
  {
    title: "Recipe Search",
    img: react_recipe_search,
    websiteUrl: "https://react-recipe-search-16a4d0.netlify.app/",
    githubUrl: "https://github.com/YourNeptune/react-recipe-search",
  },
  {
    title: "Weather App",
    img: react_weather_app,
    websiteUrl: "https://react-weather-app-92cb6b.netlify.app/",
    githubUrl: "https://github.com/YourNeptune/react-weather-app",
  },
  {
    title: "Instagram Clone",
    img: instagram_clone,
    websiteUrl: "https://react-instagram-clone-bfa83.web.app/",
    githubUrl: "https://github.com/YourNeptune/instagram-clone",
  },
  {
    title: "Messager Clone",
    img: messager_clone,
    websiteUrl: "https://facebook-messenger-clone-48827.web.app/",
    githubUrl: "https://github.com/YourNeptune/facebook-messenger-clone",
  },
  {
    title: "Redux Todo",
    img: redux_todo,
    websiteUrl: "https://redux-todo-app-5e797.web.app/",
    githubUrl: "https://github.com/YourNeptune/redux-todo-app",
  },
];

export const htmlProjects = [
  {
    title: "Sunnyside Landing Page",
    img: sunnyside_landing_page,
    websiteUrl: "https://yourneptune.github.io/Sunnyside-agency-landing-page/",
    githubUrl: "https://github.com/YourNeptune/Sunnyside-agency-landing-page",
  },
];

export const designProjects = [
  { title: "Blogs Page", img: blogPage1 },
  { title: "Blog Article Page", img: blogPage2 },
  { title: "Pricing Page", img: pricing },
  { title: "Landing Page", img: greencube_landing_page },
];
